export default __webpack_public_path__ + "static/media/this-gal.c2d602e1.gif";